import { useState, useEffect } from 'react';
import { client } from '../lib/sanity';

export const useUsefulLinks = () => {
    const [data, setData] = useState({
        title: '',
        description: '',
        links: [],
        note: '',
        loading: true,
        error: null
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const query = `*[_type == "usefulLinks"][0] {
                    title,
                    description,
                    links[] {
                        title,
                        url,
                        description
                    },
                    note
                }`;

                const result = await client.fetch(query);
                setData({
                    title: result?.title || '',
                    description: result?.description || '',
                    links: result?.links || [],
                    note: result?.note || '',
                    loading: false,
                    error: null
                });
            } catch (err) {
                setData(prev => ({
                    ...prev,
                    loading: false,
                    error: err.message
                }));
            }
        };

        fetchData();
    }, []);

    return {
        title: data.title,
        description: data.description,
        links: data.links,
        note: data.note,
        loading: data.loading,
        error: data.error
    };
}; 